import { useQuery } from "react-query";
import { getPendingInvoices } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useGetPendingInvoices = () => {
  return useQuery("GetPendingInvoices", getPendingInvoices, {
    refetchOnWindowFocus: false,
  });
};
